/** Purchase, checkout, orders, KYC, wallets, payouts, affiliates; admin money tabs (P7). */
export default {
  nav: { orders: "Orders", payouts: "Payouts", kyc: "Verification", affiliate: "Affiliate" },
  chainNames: { "tron-nile": "TRON", "ethereum-sepolia": "Ethereum" },
  chains: { "tron-nile": "USDT on the TRON Nile test network", "ethereum-sepolia": "USDT on the Ethereum Sepolia test network" },
  buy: {
    couponHave: "Have a coupon?",
    couponChecking: "Checking the coupon…",
    couponApplied: "Coupon −{amount}",
    couponRemove: "Remove the coupon",
    getFree: "Get it free",
    freeNote: "The coupon covers the whole price — nothing to pay. The account opens at once.",
    methodFree: "Free with a promo code",
    couponRefused: {
      coupon_invalid: "This code does not exist or has ended.",
      coupon_exhausted: "This code has been used up.",
      coupon_used: "You have already used this code.",
      coupon_new_users_only: "This code is for new traders only — for a first purchase.",
    },
    title: "Buy an evaluation",
    program: "Program",
    coupon: "Coupon",
    apply: "Apply",
    method: "Payment method",
    card: "Card",
    crypto: "Crypto",
    cardSoon: "Temporarily unavailable",
    coin: "Coin and network",
    feeLow: "Low network fee",
    feeHigh: "Higher network fee (gas)",
    rate: "1 {coin} ≈ {usd}",
    noCrypto: "Crypto payments are unavailable for a moment. Try again in a few minutes.",
    youGet: "What you get",
    account: "{size} {program} account",
    offer: "Bonus of this purchase",
    youSave: "You save {amount}",
    trust: {
      instant: "The account opens by itself as soon as the payment is confirmed",
      rules: "The rules are fixed for this account — the ones you see here",
      split: "Profit split up to {pct} %",
      support: "Questions before you pay? Write to {bot} on Telegram",
    },
    consentTitle: "Start right away",
    couponHint: "Optional. The discount shows on the payment page.",
    consentFirst: "Tick the box above to continue.",
    network: "Network",
    consent: "I ask that the service starts immediately. I understand that I lose my right of withdrawal once the evaluation account is opened.",
    subtotal: "Price",
    discount: "Discount",
    total: "Total",
    pay: "Continue to payment",
    rules: "Rules of this version",
    lead: "Check the program, choose how to pay and confirm. The account keeps the rules of this version until it ends.",
    size: "Account size",
    included: "What is included",
    change: "Choose another program",
  },
  steps: { program: "Program", pay: "Payment", account: "Account" },
  checkout: {
    title: "Payment",
    cardNumber: "Card number",
    testCards: "Test cards — tap one to fill it in",
    cardOk: "Approved",
    cardDeclined: "Declined",
    pay: "Pay {total}",
    declined: "The card was declined. Try the 4242 card.",
    paid: "Paid. Your account is being opened.",
    opened: "Paid. Your account is open.",
    opening: "Opening the account…",
    toAccount: "Open the account",
    sendExactly: "Send exactly {amount} {token} on {network} to:",
    expires: "The address expires {at}.",
    waiting: "Waiting for the deposit. This page updates by itself once it is confirmed.",
    sendTitle: "Pay with USDT",
    review: "The payment is being reviewed. The account opens as soon as it is confirmed.",
    closed: "This order can no longer be paid. Choose a program to start a new one.",
    notFound: "Order not found.",
    copy: "Copy",
    copied: "Copied",
    lead: "Pay for the order. The account opens as soon as the payment is confirmed.",
  },
  // ADR-0047: the live crypto payment screen.
  pay: {
    title: "Send {token}",
    on: "on {network}",
    onlyNetwork: "Only on {network}. Coins sent on another network do not arrive.",
    scan: "Scan with your wallet: network, address and amount fill in",
    amount: "Amount",
    address: "Address",
    memo: "Comment",
    memoNeed: "Add this comment to the transfer: it tells us which order you pay.",
    exactly: "Send exactly this amount. If your exchange takes its fee out of the amount, add the fee on top.",
    rate: "1 {coin} = {usd} · rate locked",
    timeLeft: "left",
    windowClosed: "The payment window is closed. A transfer that is already on its way still counts — start a new order otherwise.",
    steps: { send: "Send", seen: "Seen", confirm: "Confirmed", account: "Account" },
    waiting: "Waiting for your transfer…",
    seen: "Transfer seen · {n} of {m} confirmations",
    final: "Transfer confirmed · opening the account",
    underpaid: "{got} received. Send {amount} {token} more to finish — the amount above is updated.",
    hashTitle: "Already sent? Paste the transaction hash",
    hashLabel: "Transaction hash",
    hashCheck: "Check",
    hash: {
      credited: "Found and credited to this order.",
      confirming: "Found. Waiting for the network to confirm it.",
      review: "We could not tie it to this order automatically. Our team checks it and opens the account if it is yours.",
    },
    errors: {
      tx_not_found: "This transaction does not pay our address on this network (yet). Check the network and the hash.",
      tx_taken: "This transaction has already paid another order.",
      chain_unavailable: "The network is not answering right now. Try again in a minute — we keep watching anyway.",
      too_soon: "One check every few seconds, please.",
      rail_busy: "This coin is busy right now. Pick another network.",
      rate_unavailable: "No live rate for this coin right now. Pick another one.",
    },
    explorer: "Explorer",
    successTitle: "Your account is ready",
    successLead: "Payment confirmed. Trade the evaluation on the rules you saw.",
    tradeNow: "Trade now",
    toAccount: "Account details",
    copyAmount: "Copy amount",
    copyAddress: "Copy address",
  },
  orders: {
    title: "Orders",
    empty: "No orders yet.",
    status: { awaiting_payment: "awaiting payment", paid: "paid", provisioned: "account opened", expired: "expired", refunded: "refunded", chargeback: "charged back", manual_review: "manual review", canceled: "canceled" },
    invoice: "Invoice {n}",
    launch: "launch price",
    lead: "Every evaluation you bought, with its status and invoice.",
    emptyLead: "Pick a program to buy your first evaluation.",
    buyAnother: "Buy another",
    toPrograms: "Choose a program",
    pay: "Pay",
    openAccount: "Account",
  },
  kyc: {
    title: "Identity verification",
    why: "Required before a funded account and any payout.",
    country: "Document country",
    countryHint: "Two letters, e.g. DE, GB, UZ",
    residence: "Country of residence",
    residenceHint: "Where you live now, two letters",
    region: "Region",
    regions: { other: "Another region", ua43: "Crimea", ua40: "Sevastopol", ua14: "Donetsk region", ua09: "Luhansk region", ua23: "Zaporizhzhia region", ua65: "Kherson region" },
    number: "Document number",
    selfie: "I confirm the selfie step",
    lockedTitle: "Verification opens with your first payout",
    lockedText: "You verify your identity once, when it is needed: as soon as an account of yours passes its evaluation or a funded account reaches its first payout. Until then there is nothing to do here.",
    lockedGo: "Your accounts",
    approvedNext: "Payouts open to you as soon as a funded account is eligible.",
    pendingNote: "We review requests within one business day. This page updates by itself.",
    submit: "Submit",
    status: { started: "started", pending: "in review", approved: "approved", rejected: "rejected", retry: "please try again" },
  },
  payouts: {
    title: "Payouts",
    wallets: "Wallets",
    addWallet: "Add a wallet",
    chain: "Network",
    address: "Address",
    label: "Label",
    add: "Add",
    available: "usable from {at}",
    walletStatus: { screening: "screening", active: "active", blocked: "blocked by sanctions screening", removed: "removed" },
    remove: "Remove",
    removeConfirm: "Remove for good?",
    keep: "Keep",
    noWallets: "No wallets yet. Add the address your payouts go to.",
    addressHint: "Paste the address; the network is picked from it.",
    addressWrong: "This does not look like a {chain} address.",
    walletAdded: "Wallet added. It is screened first, then usable after the new-address delay.",
    sendTo: "Send to",
    needWallet: "Add a wallet to request this payout.",
    sent: "Payout requested. Its status is in the history below.",
    steps: {
      title: "Your first payout in four steps",
      funded: "Get a funded account",
      fundedNote: "Pass the evaluation; the funded account opens once you accept its agreement.",
      fundedGo: "Your accounts",
      kyc: "Verify your identity",
      kycNote: "Required before any payout.",
      kycGo: "Verify now",
      wallet: "Add a wallet",
      walletNote: "A TRON or Ethereum address for USDT.",
      walletGo: "Add a wallet",
      request: "Request the payout",
      requestNote: "When an account is eligible, its amount shows above with the request button.",
    },
    account: "Funded account",
    noFunded: "Payouts open on a funded account.",
    profit: "Profit",
    split: "Your split",
    amount: "You receive",
    eligible: "Eligible",
    request: "Request a payout",
    next: "Next possible date {at}",
    microDetail: "{share} % of the profit since the last payout comes from trades held under {sec} s; the limit is {max} %.",
    streakDetail: "{best} of {days} profitable days in a row so far; each day needs at least {bar}.",
    reasons: {
      no_rules: "This program has no payouts",
      kyc: "Verify your identity",
      wallet: "Add a wallet and wait for the new-address delay",
      open_positions: "Close your positions",
      first_payout_delay: "Too early for the first payout",
      cycle: "The payout cycle has not passed",
      below_minimum: "Profit below the minimum",
      profitable_days: "Not enough profitable days",
      consistency: "One day is too large a share of the profit",
      profitable_streak: "Not enough profitable days in a row",
      micro_scalping: "Too much of the profit comes from micro-scalps",
      min_trades: "Not enough closed trades",
      best_trade: "One trade is too large a share of the profit",
      max_payouts: "This account has already been paid out",
      window_open: "The session is still running: the payout opens when its clock ends",
      window_missed: "The target was not reached before the clock ran out",
      below_fee: "The processing fee would take the whole amount",
    },
    history: "History",
    status: { requested: "requested", prepared: "approval pending", paid: "paid", rejected: "rejected", failed: "failed" },
    agreement: "Funded trader agreement",
    agreementText: "Accept the funded trader agreement to open the account.",
    accept: "Accept and open the funded account",
    lead: "Your share of the profit on funded accounts: see what is still missing, pick a wallet and request it.",
    availableNow: "Available to request now",
    cap: "Cap of this payout",
    capNote: "your share is limited to it; the bonuses below come on top",
    feeRefund: "Fee refund",
    performanceReward: "Performance reward",
    haircut: "Reset penalty −{pct} %",
    haircutNote: "the account was reset after a rule violation: every payout is paid {pct} % less, for good",
    fee: "Processing fee",
    feeCell: "{base} + {pct} %",
    feeNote: "crypto payout; deducted before sending",
    feeReduced: "most of your orders were paid in crypto: 2.49 % instead of 30 %",
    net: "You receive",
    remainderSegment: "Profit above the cap stays on the account; the next payout counts new profit from there.",
    remainderCarry: "Profit above the cap stays on the account and can be taken with a later payout.",
    resetNext: "This is payout #{n}: after it the balance goes back to the start and the caps are lifted.",
    resetAt: "After payout #{n} the balance goes back to the start, then the caps are lifted.",
    funding: "Funded capital",
    fundingCell: "{funded} of {cap}",
    fundingNote: "the most one trader can hold in funded accounts, all programs together",
  },
  affiliate: {
    title: "Affiliate",
    code: "Your code",
    link: "Your link",
    rate: "Commission {pct} %, available after {days} days",
    referrals: "Referred traders",
    commissions: "Commissions",
    none: "You are not an affiliate yet.",
    status: { held: "on hold", available: "available", void: "void" },
    lead: "Share your link. Traders who sign up with it are counted here, and commissions free up after the hold.",
  },
  admin: {
    tabs: { payments: "Payments", payouts: "Payouts", kyc: "KYC", coupons: "Coupons", affiliates: "Affiliates", finance: "Finance" },
    order: "Order",
    customer: "Customer",
    amount: "Amount",
    status: "Status",
    approvePaid: "Confirm payment",
    refund: "Refund",
    chargeback: "Record a chargeback",
    reason: "Reason",
    confirmDeposit: "Record a deposit",
    received: "Received",
    confirmations: "Confirmations",
    txHash: "Transaction hash",
    record: "Record",
    prepare: "Prepare",
    approve: "Approve and send",
    reject: "Reject",
    rejectViolation: "Reject: rule violation",
    preparedBy: "prepared by {who}",
    ownPrepared: "You prepared it — another approver sends it",
    hedging: "{n} opposite positions with linked accounts in 90 days — check Fair play before approving",
    acceptLate: "Accept the late deposit",
    rail: "Rail",
    attach: "Attach a transaction",
    attachHint: "Read from the chain and checked like any payment",
    transfers: "Transfers",
    unmatched: "Transfers nobody's order took",
    unmatchedNone: "None in the last 30 days.",
    claimed: "buyer claimed order {id}",
    attachResult: "Result: {result}",
    decide: { approved: "Approve", rejected: "Reject", retry: "Ask to retry" },
    duplicate: "Same document as {email}",
    newCoupon: "New coupon",
    code: "Code",
    kind: "Type",
    value: "Value",
    maxRedemptions: "Max uses",
    used: "Used",
    create: "Create",
    newUsersOnly: "New users only",
    turnOff: "Turn off",
    turnOn: "Turn on",
    off: "off",
    reconciliation: "Reconciliation",
    providerNet: "Provider net",
    ledgerCash: "Ledger cash",
    difference: "Difference",
    unbalanced: "Unbalanced ledger transfers: {n}",
    report: "Payout ratio by cohort",
    cohort: "Cohort",
    sales: "Sales",
    revenue: "Revenue",
    paid: "Payouts",
    ratio: "Ratio",
    signal: "Above 55 % — review prices and rules",
    beta: "Beta testers: funnel for pricing",
    betaNote: "p_f — reached funded · q — funded with a paid payout · s — average paid share of the account size · p_f×q×s — expected payout per $1 of account size the price must cover.",
    challenges: "Challenges",
    funded: "Funded",
    market: "Market",
    newAffiliate: "Make a user an affiliate",
    email: "E-mail",
  },
  // ADR-0035: a bonus of a purchase (extra account, free reset) is used once its activation fee is paid.
  bonus: {
    lockedFee: "Then it is activated for {fee}.",
    available: "Ready. Pay the activation fee and the account opens.",
    availableFree: "Ready. Activate it and the account opens.",
    activate: "Activate for {fee}",
    activateFree: "Activate",
    confirmExtra: "Pay {fee} and open extra account #{n} now?",
    confirmReset: "The reset is free, but it has to be activated: {fee}. Pay and restart the evaluation now?",
    confirmResetFree: "Restart the evaluation from its starting balance now?",
    pay: "Pay {fee}",
    go: "Restart",
    cancel: "Cancel",
    resetReadyFee: "The evaluation has ended. Restart it from the starting balance on the same rules. Activation fee: {fee}.",
    resetUse: "Use the reset · {fee}",
  },
} as const;
